export const UPDATE_RECEIPTS_CURRENT_CACHE_KEY = 'UPDATE_RECEIPTS_CURRENT_CACHE_KEY';
export const GET_RECEIPTS_API_REQUEST = 'GET_RECEIPTS_API_REQUEST';
export const GET_RECEIPTS_API_SUCCESS = 'GET_RECEIPTS_API_SUCCESS';
export const GET_RECEIPTS_API_ERROR = 'GET_RECEIPTS_API_ERROR';
export const GET_NEXT_RECEIPTS_SUCCESS = 'GET_NEXT_RECEIPTS_SUCCESS';
export const GET_INDIVIDUAL_RECEIPT_API_REQUEST = 'GET_INDIVIDUAL_RECEIPT_API_REQUEST';
export const GET_INDIVIDUAL_RECEIPT_API_SUCCESS = 'GET_INDIVIDUAL_RECEIPT_API_SUCCESS';
export const GET_INDIVIDUAL_RECEIPT_API_ERROR = 'GET_INDIVIDUAL_RECEIPT_API_ERROR';
export const GET_INDIVIDUAL_RECEIPT_CANCEL = 'GET_INDIVIDUAL_RECEIPT_CANCEL';
